import { FigureVarSettingsDto, isFigureVarSettingsDto } from "./FigureVarSettingsDto";

/**
 * Defines the settings for a legend type within a figure.
 */
export interface FigureLegendSettingsDto {
  legendType: string;
  parameters: FigureVarSettingsDto[];
}

/**
 * Type guard to check if an object is a FigureLegendSettingsDto value.
 *
 * @param obj - The object to check.
 * @returns True when the value matches the legend settings shape.
 */
export const isFigureLegendSettingsDto = (obj: unknown): obj is FigureLegendSettingsDto => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureLegendSettingsDto;
  if (typeof chkObj.legendType !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.parameters)) {
    return false;
  }
  if (chkObj.parameters.some((parameter) => !isFigureVarSettingsDto(parameter))) {
    return false;
  }
  return true;
};
